import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.for-each";
import React from 'react';
export default (function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _options = {};

  var addOption = function addOption(name, Comp) {
    _options[name] = Comp;
  };

  options.forEach(function (option) {
    return addOption(option.name, option.comp);
  });
  return function (_ref) {
    var _ref$data = _ref.data,
        data = _ref$data === undefined ? {} : _ref$data;
    var Comp = _options[data.type] ? _options[data.type] : function () {
      return React.createElement('div', null);
    };
    return React.createElement(Comp, data);
  };
});